module.exports = __webpack_public_path__ + "static/media/vokalensemble.75d7aea3.jpg";